import { render } from "./reserv.vue?vue&type=template&id=45154d91"
import script from "./reserv.vue?vue&type=script&lang=ts"
export * from "./reserv.vue?vue&type=script&lang=ts"
script.render = render

export default script